export default function Page() {
    return (
      <div id="coach" className="bg-white">
        {/* Coach Section */}
        <section className="py-12 bg-white border-b border-gray-200 text-center">
          <h2 className="mt-2 text-5xl font-semibold tracking-tight text-gray-900 sm:text-6xl">Meet the Coach</h2> <br></br>
          <br></br>
          <div className="flex flex-col items-center">
            <img 
              src="/coach.jpg" 
              alt="Vaithianathan Anandhakrishnan" 
              className="w-24 h-24 rounded-full object-cover border border-gray-300 shadow-md"
            />
            <p className="text-gray-600 font-semibold mt-5 text-2xl">Vaithianathan Anandhakrishnan</p>
          </div>
        </section>
      </div>
    );
  }
  